import React from 'react'

const tuBrandLogo = ({ brand, brandLogoUrl }) => {
  const className = ''
  if (!brandLogoUrl) return null

  const srcSingle = `${brandLogoUrl}?$TuClothingLogo50$`
  const srcDouble = `${brandLogoUrl}?$TuClothingLogo100$`
  const srcSet = `${srcSingle} 1x, ${srcDouble} 2x`
  return <img alt={`${brand}-logo-img`} {...{ className, src: srcSingle, srcSet }} />
}

export default tuBrandLogo
